import React, { useEffect, useState } from 'react'
import Wrapper from '../components/Wrapper.js'
import { useNavigate, useLocation } from 'react-router-dom'
import { word } from '../word.js'
import AddTask from '../components/Agents/AddTask.js'
import Api from '../Api.js'
import { useDispatch, useSelector } from 'react-redux'
import { agentAddLocalRequest } from '../store/actions/agent.js'
import AgentElement from '../components/Agents/AgentElement.js'
import { Button, Col, Collapse, Row } from 'react-bootstrap'
import CustomPagination from '../components/BlueButton/CustomPagination.js'
import qs from "query-string";
import MyButton from '../components/Button/Button.js';
import SearchBar from '../components/SearchBar.js'
import { Slider } from '@mui/material'
import Select from "react-select";
import { taskCompanyRequest } from '../store/actions/task.js'

function valuetext(value) {
    return `${value} ֏`;
}
const customStyles = {
    menu: (provided) => ({
        ...provided,
        position: 'absolute',
        zIndex: 9999,
        maxHeight: 300,
    }),
    menuPortal: (base) => ({ ...base, margin: 0, padding: 10, zIndex: 9999 }), // Ensures portal menu is above modal
};
let minDistance = 100
export default function AgentTask() {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [show, setShow] = useState(false)
    const [open, setOpen] = useState(false)
    const [count, setCount] = useState(0)
    const [agentList, setAgent] = useState([])
    const login = useSelector((state) => state.manager.employee);
    const location = useLocation()
    const companies = useSelector((state) => state.task.companies);

    useEffect(() => {
        (async () => {
            const {data:agents} = await Api.gerAgentList()
            setAgent(agents)
            await dispatch(taskCompanyRequest())
        })();
    }, []);

    const [buttons] = useState([
        { status: "pending", title: word.new_created },
        { status: "in_progress", title: word.approved },
        { status: "process", title: word.in_the_process },
        { status: "completed", title: word.completed },
        { status: "rejected", title: word.rejected },
    ]);
    const query = qs.parse(location.search, { arrayFormat: 'comma' });
    const agentTask = useSelector((state) => state.agent.agentTask)
    // useEffect(() => {
    //     if (login?.user) {
    //         if ((localStorage.getItem("profession") !== "agent" && !login?.user?.canView) || login?.user_id !== 86) {
    //             navigate("/")
    //         }
    //     }

    // }, [login])

    useEffect(() => {
        (async () => {
            if (localStorage.getItem("in_prog")) {
                try {
                    const { data } = await Api.validateAcceptAgentTask(localStorage.getItem("in_prog"))
                    if (data.ok) {
                        await Api.acceptAgentTask({
                            task_id: data.task.id,
                            token: localStorage.getItem("in_prog").split("&")[0].replace("?token=", ""),
                            status: "in_progress",
                        })
                        navigate(`/main_employee/agent-task/${data.task.id}`)
                        localStorage.removeItem("in_prog")
                    }
                }
                catch (err) {
                    console.log(err);

                }
            }
        })()
    }, [])

    const companyParam = query.company || [];
    const agentParams = query.agent || [];

    const selectedIds = Array.isArray(companyParam)
        ? companyParam.map(String)
        : typeof companyParam === 'string'
            ? companyParam.split(',').filter(Boolean)
            : [];

    const selectedIda = Array.isArray(agentParams)
        ? agentParams.map(String)
        : typeof agentParams === 'string'
            ? agentParams.split(',').filter(Boolean)
            : [];

    const options = companies.map(c => ({ value: String(c.id), label: c.name }));
    const optionsA = agentList?.map(a => ({ value: String(a?.id), label: `${a?.user?.first_name} ${a?.user?.last_name}` }));

    const selectedOptions = options.filter(opt => selectedIds.includes(opt.value));
    const selectedOptionsA = optionsA.filter(opt => selectedIda.includes(opt.value));

    const handleFilter = (name, values) => {
        const next = { ...query };
        if (values.length) next[name] = values;
        else delete next[name];

        const querystring = qs.stringify(next, {
            arrayFormat: 'comma',
            skipEmptyString: true,
            encode: false,
        });

        navigate(querystring ? `?${querystring}` : '?', { replace: true });
    };
    const handlePageChange = async (pageNumber) => {
        query.offset = pageNumber === 1 ? '' : (pageNumber - 1) * 10;
        query.page = pageNumber;
        let querystring = qs.stringify(query, {
            arrayFormat: 'comma',
            skipEmptyString: true,
        })
        navigate(`?${querystring}`, { replace: true });
    };

    const onClose = async () => {
        setShow(false)
        const { data } = await Api.getAgentTask(query)
        setCount(data.count)
        dispatch(agentAddLocalRequest(data))
    }

    const handleTaskDelete = async (taskId) => {
        // Refresh the task list after deletion
        const { data } = await Api.getAgentTask(query)
        setCount(data.count)
        dispatch(agentAddLocalRequest(data))
    }
    const [value2, setValue2] = React.useState([20, 37]);
    const [minMax, setMinMax] = React.useState([20, 37]);

    useEffect(() => {
        (async () => {
            const { data } = await Api.getAgentTask(query)
            setCount(data.count)
            dispatch(agentAddLocalRequest(data))
        })()
    }, [location.search,])
    useEffect(() => {
        (async () => {
            const { data: min } = await Api.getPurchaseMinMax()
            setValue2([min.min_amount, min.max_amount])
            setMinMax([min.min_amount, min.max_amount])
        })()
    }, [])

    const handleChange2 = (event, newValue, activeThumb) => {
        if (newValue[1] - newValue[0] < minDistance) {
            if (activeThumb === 0) {
                const clamped = Math.min(newValue[0], 100 - minDistance);
                setValue2([clamped, clamped + minDistance]);
            } else {
                const clamped = Math.max(newValue[1], minDistance);
                setValue2([clamped - minDistance, clamped]);
            }
        } else {

            setValue2(newValue);
        }
    };

    const handleSlide = () => {
        handleFilter("amount_min", value2[0])
        handleFilter("amount_max", value2[1])
    }
    return (
        <Wrapper>
            <div className='tasks'>
                {localStorage.getItem('profession') === 'agent' ? null : <div className="plus-cont" onClick={() => setShow(true)}>
                    <span className='plus'>+</span>
                    <span className="tooltiptext">{word.addItem}</span>
                </div>}
                <Button onClick={() => setOpen(!open)}>
                    Ֆիլտրել առաջադրանքները
                </Button>
                <Collapse style={{ margin: "20px 0" }} in={open}>
                    <Row>
                        <Col md={6}>
                            <label className="count">
                                Գին
                            </label>
                            <Slider
                                getAriaLabel={() => "Purchase amount range"}
                                value={value2}
                                min={minMax[0]}
                                max={minMax[1]}
                                onChange={handleChange2}
                                valueLabelDisplay="auto"
                                getAriaValueText={valuetext}
                                disableSwap
                            />
                        </Col>
                        <Col md={12}>
                            <MyButton
                                buttonStyle={"middle-button task-button"}
                                title={"Հաստատել"} onChangeValue={handleSlide} />
                        </Col>

                        <Col md={6}>
                            Ֆիլտրել ըստ կազմակերպության

                            <Select
                                isMulti
                                options={companies.map(c => ({ value: c.id, label: c.name }))}
                                value={selectedOptions}
                                onChange={(selected) => {
                                    const values = selected?.map(o => o.value) || [];
                                    handleFilter('company', values);
                                }}
                                styles={customStyles}
                                placeholder="Ընտրել..."
                            />
                        </Col>
                        {localStorage.getItem('profession') === 'agent' ? null :<Col md={6}>
                            Ֆիլտրել ըստ ագենտի
                            <Select
                                isMulti
                                options={agentList.map(a => ({value:a?.id, label:`${a?.user?.first_name} ${a?.user?.last_name}`}))}
                                value={selectedOptionsA}
                                onChange={(ev) => {
                                    const values = ev?.map(o => o.value) || [];
                                    handleFilter('agent', values);
                                }}
                                styles={customStyles}
                                placeholder="Ընտրել..."
                            />
                        </Col>}
                    </Row>
                </Collapse>
                <div className='tasks-buttons' style={{ margin: '10px 0' }}>
                    {buttons.map((item, index) => {
                        if (item.status === "new") {
                            return null;
                        }
                        return (
                            <MyButton
                                key={index}
                                buttonStyle={(query.status !== item.status) ?
                                    "middle-button task-button" : "middle-button task-button task-button-active"}
                                title={item.title}
                                onChangeValue={() => handleFilter("status", item.status)}
                            />
                        );
                    })}
                </div>
                <SearchBar onChange={(value) => handleFilter('title', value,)} value={query.title || ""} />

                <Row className=" flex-row" style={{ marginTop: 20 }}>
                    {agentTask?.results?.length ? agentTask.results.map(l => (
                        <Col key={l.id} md={6}>
                            <AgentElement element={l} onDelete={handleTaskDelete} />
                        </Col>

                    )) : "Դեռ առաջադրանքներ չկան կամ բեռնվում է"}
                </Row>
                {count > 10 && (
                    <div className="d-flex justify-content-center">
                        <CustomPagination
                            currentPage={+query.offset ? query.offset / 10 + 1 : 1}
                            totalItems={count}
                            itemsPerPage={10}
                            totalPages={Math.ceil(count / 10) || 0}
                            onPageChange={(newPage) => handlePageChange(newPage)}
                        />
                    </div>
                )}
            </div>
            {show ? <AddTask show={show} onHide={onClose} /> : null}
        </Wrapper>
    )
}
